import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import cx from 'classnames'
import styles from './Header.module.scss'
import logo from '../../assets/images/optimized/logo-minha-fono.webp'
import { NAV_LINKS, openWhatsApp } from '../constants'
import { ROUTES } from '../../appRoutes'

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [activeId, setActiveId] = useState('inicio')

  const closeMenu = () => setMenuOpen(false)

  // Scrollspy: highlight the nav link whose section is crossing the viewport
  // center. The thin rootMargin band means only one section is active at a time.
  useEffect(() => {
    const sections = NAV_LINKS.map(link => document.getElementById(link.href.slice(1))).filter(
      (el): el is HTMLElement => el !== null,
    )
    if (!sections.length) return

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) setActiveId(entry.target.id)
        })
      },
      { rootMargin: '-50% 0px -50% 0px', threshold: 0 },
    )

    sections.forEach(section => observer.observe(section))
    return () => observer.disconnect()
  }, [])

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <a href="#inicio" className={styles.brand} onClick={closeMenu}>
          <img
            src={logo}
            alt="Minha Fono Online"
            className={styles.brandLogo}
            width={318}
            height={62}
          />
        </a>

        <nav className={cx(styles.nav, { [styles.navOpen]: menuOpen })}>
          {NAV_LINKS.map(link => (
            <a
              key={link.href}
              href={link.href}
              className={cx({ [styles.active]: activeId === link.href.slice(1) })}
              onClick={closeMenu}
            >
              {link.label}
            </a>
          ))}
          <a href="/blog/" onClick={closeMenu}>
            Blog
          </a>
          <Link to={ROUTES.login} className={styles.loginLink} onClick={closeMenu}>
            Login
          </Link>
        </nav>

        <div className={styles.actions}>
          <button type="button" className={styles.cta} onClick={openWhatsApp}>
            Agendar avaliação <i className="material-icons">chat</i>
          </button>
          <button
            type="button"
            className={styles.burger}
            aria-label="Abrir menu"
            onClick={() => setMenuOpen(open => !open)}
          >
            <i className="material-icons">{menuOpen ? 'close' : 'menu'}</i>
          </button>
        </div>
      </div>
    </header>
  )
}

export default Header
